import { AppServices } from '@singularsystems/neo-core';

import { Types as CommonTypes } from 'st-common/Awards/CommonAwardsTypes';
import { IMyAwardsApiClient } from './ApiClients/ParticipantOffers/MyAwardsApiClient';
import { IAwardDocumentsQueryApiClient } from 'st-common/Awards/ApiClients/AwardDocuments/AwardDocumentsQueryApiClient';
import AwardsDataCache from './Services/AwardsDataCache';

// Symbols to expose outside of this module
export const AwardsSharedTypes = {
    ApiClients: {
        ApprovalsQueryApiClient: CommonTypes.ApiClients.ApprovalsQueryApiClient,
        MyAwardsApiClient: new AppServices.ServiceIdentifier<IMyAwardsApiClient>("Awards.ApiClients.MyAwardsApiClient"),
        AwardDocumentsQueryApiClient: new AppServices.ServiceIdentifier<IAwardDocumentsQueryApiClient>("Awards.ApiClients.AwardDocumentsQueryApiClient"),
        CatalogueQueryApiClient: CommonTypes.ApiClients.CatalogueQueryApiClient,
    },
    Services: {
        AwardsDataCache: new AppServices.ServiceIdentifier<AwardsDataCache>("Awards.Services.AwardsDataCache"),        
    }
}